import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  // Lock body scroll when modal is open
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [activeModal]);
  const closeModal = () => setActiveModal(null);
  return <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm border-t border-slate-800" data-id="element-47">
      <div className="container mx-auto px-4" data-id="element-48">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-8" data-id="element-49">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-emerald-400 transition-colors underline decoration-slate-700 underline-offset-4 hover:decoration-emerald-400" data-id="element-50">
            Política de Privacidad
          </button>
          <span className="hidden md:inline text-slate-700" data-id="element-51">•</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-emerald-400 transition-colors underline decoration-slate-700 underline-offset-4 hover:decoration-emerald-400" data-id="element-52">
            Términos y Condiciones
          </button>
        </div>

        <p className="mb-4" data-id="element-53">
          &copy; {new Date().getFullYear()} Rodillas Jóvenes. Todos los derechos
          reservados.
        </p>
        <p className="max-w-2xl mx-auto text-xs text-slate-600" data-id="element-54">
          Descargo de responsabilidad: Este producto no sustituye el consejo
          médico profesional. Consulte a su médico antes de comenzar cualquier
          programa de ejercicios. Los resultados pueden variar.
        </p>
      </div>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/80 backdrop-blur-sm animate-in fade-in duration-200" onClick={closeModal} data-id="element-55">
          {/* Modal Content */}
          <div className="bg-white text-slate-900 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col relative animate-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-56">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-slate-100" data-id="element-57">
              <h3 className="text-xl font-bold text-slate-900" data-id="element-58">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={closeModal} className="p-2 hover:bg-slate-100 rounded-full transition-colors text-slate-500 hover:text-slate-900" aria-label="Cerrar" data-id="element-59">
                <X className="h-5 w-5" data-id="element-60" />
              </button>
            </div>

            {/* Scrollable Body */}
            <div className="p-6 overflow-y-auto text-left space-y-4 text-slate-600 leading-relaxed" data-id="element-61">
              {activeModal === 'privacy' && <>
                  <p data-id="element-62">
                    <strong data-id="element-63">1. Recopilación de información</strong>
                  </p>
                  <p data-id="element-64">
                    Recopilamos información cuando te registras en nuestro
                    sitio, realizas un pedido o te suscribes a nuestro boletín.
                    La información recopilada incluye tu nombre y dirección de
                    correo electrónico.
                  </p>

                  <p data-id="element-65">
                    <strong data-id="element-66">2. Uso de la información</strong>
                  </p>
                  <p data-id="element-67">
                    Cualquier información que recopilamos de ti puede usarse
                    para personalizar tu experiencia, mejorar nuestro sitio web,
                    mejorar el servicio al cliente y procesar transacciones.
                  </p>

                  <p data-id="element-68">
                    <strong data-id="element-69">3. Protección de la información</strong>
                  </p>
                  <p data-id="element-70">
                    Implementamos una variedad de medidas de seguridad para
                    mantener la seguridad de tu información personal. No
                    vendemos, intercambiamos ni transferimos a terceros tu
                    información de identificación personal.
                  </p>

                  <p data-id="element-71">
                    <strong data-id="element-72">4. Cookies</strong>
                  </p>
                  <p data-id="element-73">
                    Utilizamos cookies para mejorar el acceso a nuestro sitio e
                    identificar a los visitantes recurrentes. Además, nuestras
                    cookies mejoran la experiencia del usuario mediante el
                    seguimiento y la orientación de sus intereses.
                  </p>
                </>}

              {activeModal === 'terms' && <>
                  <p data-id="element-74">
                    <strong data-id="element-75">1. Aceptación de los términos</strong>
                  </p>
                  <p data-id="element-76">
                    Al acceder a este sitio web, aceptas estar sujeto a estos
                    Términos y Condiciones de uso, todas las leyes y
                    regulaciones aplicables, y aceptas que eres responsable del
                    cumplimiento de las leyes locales aplicables.
                  </p>

                  <p data-id="element-77">
                    <strong data-id="element-78">2. Licencia de uso</strong>
                  </p>
                  <p data-id="element-79">
                    Se concede permiso para descargar temporalmente una copia de
                    los materiales (información o software) en el sitio web de
                    Rodillas Jóvenes solo para visualización transitoria
                    personal y no comercial.
                  </p>

                  <p data-id="element-80">
                    <strong data-id="element-81">3. Descargo de responsabilidad</strong>
                  </p>
                  <p data-id="element-82">
                    Los materiales en el sitio web de Rodillas Jóvenes se
                    proporcionan "tal cual". Rodillas Jóvenes no ofrece
                    garantías, expresas o implícitas, y por la presente renuncia
                    y niega todas las demás garantías.
                  </p>

                  <p data-id="element-83">
                    <strong data-id="element-84">4. Limitaciones</strong>
                  </p>
                  <p data-id="element-85">
                    En ningún caso Rodillas Jóvenes o sus proveedores serán
                    responsables de ningún daño (incluidos, entre otros, daños
                    por pérdida de datos o beneficios, o debido a la
                    interrupción del negocio) que surjan del uso o la
                    imposibilidad de usar los materiales.
                  </p>

                  <p data-id="element-86">
                    <strong data-id="element-87">5. Revisiones y erratas</strong>
                  </p>
                  <p data-id="element-88">
                    Los materiales que aparecen en el sitio web podrían incluir
                    errores técnicos, tipográficos o fotográficos. No
                    garantizamos que ninguno de los materiales en su sitio web
                    sea preciso, completo o actual.
                  </p>
                </>}
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-slate-100 bg-slate-50 rounded-b-2xl flex justify-end" data-id="element-89">
              <button onClick={closeModal} className="px-6 py-2 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors font-medium text-sm" data-id="element-90">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </footer>;
}